import { useState, useEffect, useRef } from 'react';

export const useAnimatedNumber = (targetValue, duration = 1000) => {
  const [displayValue, setDisplayValue] = useState(targetValue);
  const animationRef = useRef(null);
  const startValueRef = useRef(targetValue);
  const startTimeRef = useRef(null);

  useEffect(() => {
    if (displayValue === targetValue) return;

    // Cancel any existing animation
    if (animationRef?.current) {
      cancelAnimationFrame(animationRef?.current);
    }

    startValueRef.current = displayValue;
    startTimeRef.current = null;

    const animate = (currentTime) => {
      if (!startTimeRef?.current) {
        startTimeRef.current = currentTime;
      }

      const elapsed = currentTime - startTimeRef?.current;
      const progress = Math.min(elapsed / duration, 1);

      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      
      const currentValue = Math.round(
        startValueRef?.current + (targetValue - startValueRef?.current) * easeOutQuart
      );

      setDisplayValue(currentValue);

      if (progress < 1) {
        animationRef.current = requestAnimationFrame(animate);
      }
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      if (animationRef?.current) {
        cancelAnimationFrame(animationRef?.current);
      }
    };
  }, [targetValue, duration]);

  return displayValue;
};